import React, { useEffect, useState } from "react";
import { Input, Select, Divider, Switch } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useProjectState } from "../../../../context/stateContext";

const EditTabsGeneralSettings = ({ sendGeneralState, organization }) => {
  const [name, setName] = useState(null);
  const [displayNameBulgarian, setDisplayNameBulgarian] = useState(null);
  const [displayNameEnglish, setDisplayNameEnglish] = useState(null);
  const [note, setNote] = useState(null);
  const [city, setCity] = useState(null);
  const [touchSaleDatabaseSource, setTouchSaleDatabaseSource] = useState(null);
  const [touchSaleDatabasePort, setTouchSaleDatabasePort] = useState(null);
  const [touchSaleDatabase, setTouchSaleDatabase] = useState(null);
  const [touchSaleDatabaseUserName, setTouchSaleDatabaseUserName] =
    useState(null);
  const [touchSaleDatabasePassword, setTouchSaleDatabasePassword] =
    useState(null);
  const [defaultTouchSaleRestaurantId, setDefaultTouchSaleRestaurantId] =
    useState(null);
  const [multipleRestaurants, setMultipleRestaurants] = useState(false);

  // Новите useState за Aton
  const [atonDatabaseSource, setAtonDatabaseSource] = useState(null);
  const [atonDatabasePort, setAtonDatabasePort] = useState(null);
  const [atonDatabase, setAtonDatabase] = useState(null);
  const [atonDatabaseUserName, setAtonDatabaseUserName] = useState(null);
  const [atonDatabasePassword, setAtonDatabasePassword] = useState(null);

  const { cities, organizationRestaurants } = useSelector(
    (state) => state.organizationsReducer
  );

  const { openEditOrganizationModal } = useProjectState();

  const generalState = {
    name,
    displayNameBulgarian,
    displayNameEnglish,
    note,
    city,
    touchSaleDatabaseSource,
    touchSaleDatabasePort,
    touchSaleDatabase,
    touchSaleDatabaseUserName,
    touchSaleDatabasePassword,
    defaultTouchSaleRestaurantId,
    multipleRestaurants,
    // Добавяме новите полета
    atonDatabaseSource,
    atonDatabasePort,
    atonDatabase,
    atonDatabaseUserName,
    atonDatabasePassword,
  };

  useEffect(() => {
    sendGeneralState(generalState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(generalState)]);

  useEffect(() => {
    setName(organization?.name);
    setDisplayNameBulgarian(organization?.displayNameBulgarian);
    setDisplayNameEnglish(organization?.displayNameEnglish);
    setNote(organization?.note);
    setCity(organization?.city);
    setTouchSaleDatabaseSource(organization?.touchSaleDatabaseSource);
    setTouchSaleDatabasePort(organization?.touchSaleDatabasePort);
    setTouchSaleDatabase(organization?.touchSaleDatabase);
    setTouchSaleDatabaseUserName(organization?.touchSaleDatabaseUserName);
    setTouchSaleDatabasePassword(organization?.touchSaleDatabasePassword);
    setDefaultTouchSaleRestaurantId(organization?.defaultTouchSaleRestaurantId);
    setMultipleRestaurants(organization?.multipleRestaurants);

    // Инициализация на новите полета
    setAtonDatabaseSource(organization?.atonDatabaseSource);
    setAtonDatabasePort(organization?.atonDatabasePort);
    setAtonDatabase(organization?.atonDatabase);
    setAtonDatabaseUserName(organization?.atonDatabaseUserName);
    setAtonDatabasePassword(organization?.atonDatabasePassword);

    // ...ако искаш да ги нулираш, добави тук setAtonDatabaseSource(null) и т.н.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization, openEditOrganizationModal]);

  const citiesArrayForSelect = cities.map((city, index) => {
    return {
      key: index,
      value: city,
      label: city,
    };
  });

  const defaultTouchSaleRestaurantArray = organizationRestaurants?.map(
    (item) => ({
      label: (
        <>
          {item.name} <span style={{ opacity: 0.5 }}>(Id: {item.id})</span>
        </>
      ),
      value: item.id,
    })
  );

  return (
    <>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Портал име
          </label>
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Име (Български)
          </label>
          <Input
            value={displayNameBulgarian}
            onChange={(e) => setDisplayNameBulgarian(e.target.value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Име (Английски)
          </label>
          <Input
            value={displayNameEnglish}
            onChange={(e) => setDisplayNameEnglish(e.target.value)}
          />
        </div>
      </div>

      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Описание
          </label>
          <Input value={note} onChange={(e) => setNote(e.target.value)} />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">Град</label>
          <Select
            value={city}
            options={citiesArrayForSelect}
            className="admin-organization-full-width"
            onChange={(value) => setCity(value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Основен ресторант{" "}
            <span className="admin-organization-input-label-require">*</span>
          </label>
          <Select
            value={
              organizationRestaurants.length === 0
                ? { value: 1, label: 1 }
                : defaultTouchSaleRestaurantId
            }
            className="admin-organization-edit-general-default-restaurant-input"
            options={defaultTouchSaleRestaurantArray}
            placeholder="Основен ресторант"
            onChange={(value) => {
              setDefaultTouchSaleRestaurantId(value);
            }}
          ></Select>
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            Избор на ресторанти
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={multipleRestaurants}
            onChange={(value) => setMultipleRestaurants(value)}
          />
        </div>
      </div>
      <Divider />
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            TouchSale IP
          </label>
          <Input
            value={touchSaleDatabaseSource}
            placeholder="xxx.xxx.xxx.xxx"
            onChange={(e) => setTouchSaleDatabaseSource(e.target.value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            TouchSale Port
          </label>
          <Input
            value={touchSaleDatabasePort}
            placeholder="3050"
            onChange={(e) => setTouchSaleDatabasePort(e.target.value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            TouchSale Database
          </label>
          <Input
            value={touchSaleDatabase}
            placeholder="Alias"
            onChange={(e) => setTouchSaleDatabase(e.target.value)}
          />
        </div>
      </div>

      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            TouchSale Потребител
          </label>
          <Input
            value={touchSaleDatabaseUserName}
            placeholder="sysdba"
            onChange={(e) => setTouchSaleDatabaseUserName(e.target.value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            TouchSale Парола
          </label>
          <Input
            value={touchSaleDatabasePassword}
            placeholder="masterkey"
            onChange={(e) => setTouchSaleDatabasePassword(e.target.value)}
          />
        </div>
      </div>

      {/* Новите полета за Aton */}
      <Divider />
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">Aton IP</label>
          <Input
            value={atonDatabaseSource}
            placeholder="xxx.xxx.xxx.xxx"
            onChange={(e) => setAtonDatabaseSource(e.target.value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Aton Port
          </label>
          <Input
            value={atonDatabasePort}
            placeholder="3050"
            onChange={(e) => setAtonDatabasePort(e.target.value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Aton Database
          </label>
          <Input
            value={atonDatabase}
            placeholder="Alias"
            onChange={(e) => setAtonDatabase(e.target.value)}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Aton Потребител
          </label>
          <Input
            value={atonDatabaseUserName}
            placeholder="sysdba"
            onChange={(e) => setAtonDatabaseUserName(e.target.value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Aton Парола
          </label>
          <Input
            value={atonDatabasePassword}
            placeholder="masterkey"
            onChange={(e) => setAtonDatabasePassword(e.target.value)}
          />
        </div>
      </div>
      {/* <Divider /> */}
    </>
  );
};

export default EditTabsGeneralSettings;
